/* tslint:disable */
require('./FieldRenderer.module.css');
const styles = {
  ellipsis: 'ellipsis_0c6115a5',
  relative: 'relative_0c6115a5',
  fabricIcon: 'fabricIcon_0c6115a5',
};

export default styles;
/* tslint:enable */